import { css } from "lit";

export const styles = css`
  :host {
    --presentation-scale: 1;
  }

  .slide-presentation {
    background-color: var(--presentation-background-color, #fff);
    width: 100%;
    display: block;
    overflow: hidden;
    position: relative;
    z-index: 0; /* Fixes bug where border-radius would break on transforms. */
  }

  .decoration-rounded,
  .decoration-border,
  .decoration-box-shadow {
    border-radius: var(--size-1-5);
  }

  .decoration-border,
  .decoration-box-shadow {
    border: none;
  }

  .decoration-box-shadow {
    box-shadow: var(--shadow-md);
  }

  .default,
  .mobile {
    aspect-ratio: 16 / 9;
  }

  .tall {
    height: 100%;
  }

  .tall .scaled-slides {
    height: var(--tall-mode-unscaled-height);
  }

  .scaled-slides {
    transform: scale(var(--presentation-scale));
    transform-origin: top left;
    position: absolute;
    top: 0;
    left: var(--presentation-margin, 0);
  }
`;
